import React, { type FC } from 'react';
import { Col, Row, Skeleton, Statistic, Tag, type TagProps } from 'antd';

import styles from './geektasks.module.scss';

type TaskTypeCount = { ID: number; label: string; count: number };

type SummaryItemProps = {
  color: TagProps['color'];
  name: string;
  data?: TaskTypeCount[];
};

export const SummaryItem: FC<SummaryItemProps> = ({ color, name, data }) => {
  return (
    <Row wrap={false}>
      <Col flex="125px" style={{ marginRight: 16 }}>
        <Tag style={{ width: '100%', margin: 0 }} color={color}>
          {name}
        </Tag>
      </Col>
      <Col flex="auto" style={{ display: 'flex', flexWrap: 'wrap' }}>
        {!data ? (
          <Skeleton active paragraph={false} />
        ) : data?.length ? (
          data.map(({ ID, label, count }) => (
            <Statistic key={ID} title={label} value={count} className={styles.geektasks__task_summary__item} />
          ))
        ) : (
          <Statistic key={'blank'} value={0} className={styles.geektasks__task_summary__item} />
        )}
      </Col>
    </Row>
  );
};
